import { useCallback, useMemo } from "react";
import { useLivePreview } from "@payloadcms/live-preview-react";
import { getPayloadCmsUrl } from "src/api/payload/client";
import { mapEntertainmentEvent } from "src/utils/mapEntertainment";
import { entertainmentLivePreviewRequestHandler } from "src/utils/entertainmentLivePreviewHandler";
import { isPayloadEntertainmentSource } from "src/utils/entertainmentSource";

/**
 * Live preview for a single entertainment hub card (admin iframe on /entertainment/preview).
 *
 * @param {string} [locale] - `en` | `fr`
 */
export function useEntertainmentCardLivePreview(locale) {
  const enabled = isPayloadEntertainmentSource();
  const initialDoc = useMemo(() => ({}), []);
  const requestHandler = useCallback(entertainmentLivePreviewRequestHandler, []);

  const { data: liveDoc, isLoading } = useLivePreview({
    initialData: initialDoc,
    serverURL: getPayloadCmsUrl(),
    depth: 1,
    requestHandler,
  });

  const card = useMemo(() => {
    if (!enabled || !liveDoc?.name) return null;
    return mapEntertainmentEvent(liveDoc, locale);
  }, [enabled, liveDoc, locale]);

  return {
    card,
    isLoading: enabled && isLoading,
    isLivePreview: Boolean(liveDoc?.name),
  };
}
